module.exports = __webpack_public_path__ + "img/arrow-left.7096e827.svg";